import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Option, OptionState } from '@app/shared/types';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatIconModule } from '@angular/material/icon';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

interface SingleSelectOutput {
  id: string;
  value: string;
}

@Component({
  selector: 'app-single-select',
  standalone: true,
  imports: [
    CommonModule,
    MatSelectModule,
    MatFormFieldModule,
    MatInputModule,
    MatAutocompleteModule,
    MatIconModule,
    ReactiveFormsModule,
    FormsModule,
  ],
  templateUrl: './single-select.component.html',
  styleUrls: ['./single-select.component.css'],
})
export class SingleSelectComponent implements OnInit {
  @Input() public data: {
    state: OptionState;
    label: string;
  };
  @Output() output = new EventEmitter<SingleSelectOutput>();

  public selected: Option | null = null;
  public searchText: string = '';
  public filteredOptions: Option[] = [];

  ngOnInit(): void {

    const masterOptions = this.data?.state?.options || [];

    this.filteredOptions = [...masterOptions];

    const initialSelected = masterOptions.find((option) => option.selected);
    if (initialSelected) {
      this.selected = initialSelected;
      this.searchText = initialSelected.label;
    }
  }

  openOptions() {
    this.searchText = ''
    this.filteredOptions = this.data?.state?.options || [];
  }

  filterOptions(value: any) {

    const stringValue = typeof value === 'object' && value !== null ? value.label : value;
    
    const term = stringValue ? stringValue.toLowerCase().trim() : '';
    const masterOptions = this.data?.state?.options || [];

    if (!term) {
      this.filteredOptions = [...masterOptions];
      this.selected = null; 
      this.emitOutput('');
      return;
    }

    this.filteredOptions = masterOptions.filter((option) =>
      option.label?.toLowerCase().includes(term)
    );
  }


  onOptionSelected(option: Option) {
    this.selected = option;
    this.searchText = option.label;
    this.emitOutput(option.value);
  }

  private emitOutput(value: string) {
    this.output.emit({
      id: this.data.state.id,
      value: value,
    });
  }

  displayFn(option: Option): string {
  return option && option.label ? option.label : '';
}
}